import { render, staticRenderFns } from "./PaymentFooter.vue?vue&type=template&id=7a646bb8&scoped=true"
import script from "./PaymentFooter.vue?vue&type=script&lang=js"
export * from "./PaymentFooter.vue?vue&type=script&lang=js"
import style0 from "./PaymentFooter.vue?vue&type=style&index=0&id=7a646bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a646bb8",
  null
  
)

export default component.exports